import { render, staticRenderFns } from "./NewTest.vue?vue&type=template&id=74e93524&"
import script from "./NewTest.vue?vue&type=script&lang=js&"
export * from "./NewTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports